<template>

</template>
<script>
import { usersRef } from '../../firebase'

export default {
  props: {
    hasOrder: { default: false }
  },
  methods: {
    async addOrder() {
      const uid = this.$store.getters.uid
      usersRef
        .child(uid)
        .child('order')
        .set(null)
        .then(() => {
          this.$store.commit('isLoading', true)
          this.$router.push('/location')
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Order/NewOrderMessage.vue